export const PAYER_SEARCH_FILTERS = {
  id: {
    title: 'ID',
    placeholder: 'Search by ID',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'text-num-mono'
  },
  name: {
    title: 'Name',
    placeholder: 'Search by name',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'first-line-mono'
  }
};
